import { useRef, useEffect } from "react";
import VolumeIcon from "./VolumeIcon";
import Hls from "hls.js/dist/hls.js";

const AudioPlayer = ({ audio_url }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    let hls;

    if (Hls.isSupported() && video) {
      hls = new Hls();
      hls.loadSource(audio_url);
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js error:", data);
      });
    } else if (video && video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = audio_url;
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [audio_url]);

  return (
    <audio
      ref={videoRef}
      controls
      style={{ width: "50%", borderRadius: "10px" }}
    />
  );
};

export default AudioPlayer;
